const t = {
  name: "Plant",
  dimensions: { width: 22, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22 40" style="enable-background:new 0 0 22 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h5c3.9,0,7,3.1,7,7v5.1c1.3-1.3,3-2.1,5-2.1h5v5c0,3.9-3.1,7-7,7h-3v4h7v14H3V26h7V12H7c-3.9,0-7-3.1-7-7
			V0z M12,20h3c2.8,0,5-2.2,5-5v-3h-3c-2.8,0-5,2.2-5,5V20z M2,2v3c0,2.8,2.2,5,5,5h3V7c0-2.8-2.2-5-5-5H2z M5,32v6h12v-6H5z M5,30
			h12v-2H5V30z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as Plant
};
